module.exports = __webpack_public_path__ + "img/cone.72d60ef4.png";